import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUser,
    faArrowDownShortWide,
    faTicket,
    faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-solid-svg-icons/faHeart";
import { useNavigate } from 'react-router-dom';

const MyProfilesidebar = () => {
    const navigation = useNavigate();
    const [userName, setUserName] = useState('');

    useEffect(() => {
        const storedName = localStorage.getItem('userName');
        if (storedName) setUserName(storedName);
    }, []);

    const logoutClick = () => {
        // ✅ Clear both guest and user session data
        localStorage.removeItem('userName');
        localStorage.removeItem('userId');
        localStorage.removeItem('guest_id');
        localStorage.removeItem('hasShownPopup');

        // Optional: refresh the page so UI updates instantly
        // window.location.reload();

        navigation('/');
    };

    const navWishlist = () => {
        navigation('/wishlist');
    };
    
    const couponsnav = () => {
        navigation('/Coupouns');
    };

    const myprofilenav = () => {
        navigation('/myprofile');
    };

    const oredersnav = () => {
        navigation("/Orders");
    };

    return (
        <div className='myprofile-sidebar-bg'>
            <div className='row'>
                <div className='col-lg-12'>
                    <div className='maintitle-bg'>
                        <div className='overview-title-bg'>
                            <h4>{userName ? userName.charAt(0) : 'A'}</h4>
                        </div>
                        <h4>{userName}</h4>
                    </div>
                    <div className='myprofile-items' onClick={myprofilenav}>
                        <FontAwesomeIcon icon={faUser} />
                        <h6>My Profile</h6>
                    </div>
                    <div className='myprofile-items' onClick={oredersnav}>
                        <FontAwesomeIcon icon={faArrowDownShortWide} />
                        <h6>Orders</h6>
                    </div>
                    <div className='myprofile-items' onClick={navWishlist}>
                        <FontAwesomeIcon icon={faHeart} />
                        <h6>Wishlist</h6>
                    </div>
                    <div className='myprofile-items' onClick={couponsnav}>
                        <FontAwesomeIcon icon={faTicket} />
                        <h6>Coupons</h6>
                    </div>
                    <div className='myprofile-items myprofile-logout' onClick={logoutClick}>
                        <FontAwesomeIcon icon={faRightFromBracket} />
                        <h6>Logout</h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyProfilesidebar;
